module.exports = __webpack_public_path__ + "img/home-family-s.b77c04bf.jpg";